export const TOOLTIP_TEXTS = {
  DEBT: 'Amount of outstanding debt for the token',
  APR: 'An annual percentage rate that combines collateral yield and loan interest rates to show the total interest cost or yield in one clear rate',
  PNL: 'Net profit or loss',
}
